import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { FormDropDownParticleSpec } from "components/cards/particles/YinzCam/Core/FormDropDown";
import { FormTextInputParticleSpec } from "components/cards/particles/YinzCam/Core/FormTextInput";
import { FormTextAreaParticleSpec } from "components/cards/particles/YinzCam/Core/FormTextArea";
import { ButtonParticleSpec } from "components/cards/particles/YinzCam";
import { TextParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Contact Form Atom", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  fullNameInput: FormTextInputParticleSpec.generateSchema("Full Name Input", "Text input for full name."),
  emailInput: FormTextInputParticleSpec.generateSchema("Email Input", "Text input for email address."),
  subjectDropdown: FormDropDownParticleSpec.generateSchema("Subject Dropdown", "Dropdown for Subject"),
  messageInput: FormTextAreaParticleSpec.generateSchema("Message Input", "Text area input for message."),
  submitButton: ButtonParticleSpec.generateSchema("Submit Button","Contact Form Submit Button", {
    defaultValues: { text: { text: "SUBMIT", size: "12px", weight: "700" } }
  }),
  errorMessage: TextParticleSpec.generateSchema("Error message", "Error message to display", {
    defaultValues: { text: "PLEASE REVIEW YOUR RESPONSE", color: "#ff4800", size: "12px", weight: "700" }
  }),
  serviceMessage: TextParticleSpec.generateSchema("Service error message", "Service error message to display", {
    defaultValues: { text: "SUBMISSION FAILED. PLEASE TRY AGAIN.", color: "#ff4800", size: "12px", weight: "700" }
  }),
  submittedMessage: TextParticleSpec.generateSchema("Submitted message", "Message to display after submission", {
    defaultValues: {
      container: { centerContentHorizontally: true, centerContentVertically: true }, 
      text: "THANK YOU FOR YOUR RESPONSE. WE WILL BE IN TOUCH SOON WITH FURTHER DETAILS.", 
      color: "white", 
      size: "24px",
      weight: "700",
      align: "center" 
    }
  }),
}));